import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { HttpRequest } from "@/core/common/http/http-request";
import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { CreateFileDto } from "@/core/features/file/create-file.dto";
import { CreateUserHasQualificationHasFileDto } from "@/core/features/users-have-qualifications-have-files/create-user-has-qualification-has-file.dto";
import { UpdateUserHasQualificationHasFileDto } from "@/core/features/users-have-qualifications-have-files/update-user-has-qualification-has-file.dto";
import { UserHasQualificationFileListItemDto } from "@/core/features/users-have-qualifications-have-files/user-has-qualification-file-list-item.dto";
import { UserHasQualificationHasFileDto } from "@/core/features/users-have-qualifications-have-files/user-has-qualification-has-file.dto";
import { plainToInstance } from "class-transformer";

export class UsersHaveQualificationsHaveFilesResource extends ResourceBaseService<
  UserHasQualificationHasFileDto,
  CreateUserHasQualificationHasFileDto,
  UpdateUserHasQualificationHasFileDto
> {
  protected EntityDto = UserHasQualificationHasFileDto;
  protected CreateEntityDto = CreateUserHasQualificationHasFileDto;
  protected UpdateEntityDto = UpdateUserHasQualificationHasFileDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/users-have-qualifications-have-files");
  }

  createManyAttachments(
    userHasQualificationId: string,
    files: CreateFileDto[]
  ): Promise<UserHasQualificationHasFileDto[]> {
    return this.apiHttpClient.request(
      HttpRequest.create({
        url: this.resourceUrl + "/" + userHasQualificationId + "/attachments",
        method: "POST",
        auth: true,
        body: { bulk: files },
      })
    );
  }

  async listByEmployee(userId: string): Promise<UserHasQualificationFileListItemDto[]> {
    const rows = await this.apiHttpClient.request<null, UserHasQualificationFileListItemDto[]>(
      HttpRequest.create({
        url: this.resourceUrl + "/by-employee/" + userId,
        method: "GET",
        auth: true,
      })
    );

    return plainToInstance(UserHasQualificationFileListItemDto, rows);
  }
}
